export default {
  EXERCISE: 'exercise',
  WORKOUT: 'workout',
  TRAINING_PLAN: 'training_plan',
  TRAINING_PLANS: 'training_plans',
};
